export default {
  type: 'T',
  render: (value) =>
    value && value.length > 10 ? `${value.substr(0, 7)}...` : value,
  compare: (a, b) => (a ? a.localeCompare(b) : -1)
}
